// Minimal-Button mit drei Variants. Bewusst eine eigene Komponente,
// damit Hover/Focus/Disabled-Verhalten projektweit identisch ist.

import type { ButtonHTMLAttributes, ReactNode } from "react";

import "./Button.css";

type Variant = "primary" | "secondary" | "ghost" | "danger";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: "sm" | "md";
  // Zeigt einen Spinner links vom Text und setzt den Button automatisch
  // disabled, damit der User nicht doppelt klicken kann waehrend die
  // Aktion laeuft. Text bleibt sichtbar (keine Breiten-Spruenge).
  loading?: boolean;
}

export function Button({
  variant = "primary",
  size = "md",
  loading = false,
  disabled,
  className,
  children,
  ...rest
}: ButtonProps) {
  const cls = [
    "bmd-btn",
    `bmd-btn-${variant}`,
    `bmd-btn-${size}`,
    loading && "bmd-btn-loading",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button
      {...rest}
      className={cls}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
    >
      {loading && (
        <span
          className="bmd-btn-spinner"
          aria-hidden="true"
        />
      )}
      <span className="bmd-btn-label">{children as ReactNode}</span>
    </button>
  );
}
